export const RECENT = 'recent';
export const POPULAR = 'popular';
export const TRENDING = 'trending';
export const CATEGORIES = 'categories';
export const ARTISTS = 'artists';
export const FALLBACK = 'fallback';
// Search terms, as opposed to people or scoped links. A single list merged from
// trending_searches and popular_searches_v2. See mergeByPriority in ../utils.
export const SEARCHES = 'searches';

// `source_type` records which upstream list a merged search came from. It's
// reported to analytics as `category_selected`, so these values are contractual.
export const SOURCE_TRENDING = 'trending';
export const SOURCE_POPULAR_V2 = 'popular_v2';

export const TYPE_ORDER_FOCUS = [RECENT, TRENDING];
// CATEGORIES renders nothing while typing: merged searches are product-agnostic
// and carry no ia_code, which is what formatShowAll filters on.
export const TYPE_ORDER_TYPING = [SEARCHES, ARTISTS, FALLBACK, CATEGORIES];

export const FOCUS_SCREEN = 'focus_screen';
export const TYPING_SCREEN = 'typing_screen';
